import mixpanel from 'mixpanel-browser';
import { IPeopleProperty } from '../flows/login/login.service';

const KEY =
  process.env.REACT_APP_NODE_ENV === 'production'
    ? process.env.REACT_APP_MIX_PANEL_PROD
    : process.env.REACT_APP_MIX_PANEL_INTEG;

export const initMixPanel = () => {
  mixpanel.init(KEY || '', { debug: true });
  mixpanel.track('Mixpanel Initialized', { appVersion: process.env.REACT_APP_VERSION });
};

export const identifyMixPanelUser = async (customerId: string) => {
  if (!customerId) {
    await mixpanel.reset();
  } else {
    await mixpanel.identify(customerId);
  }
};

export const setPeopleProperty = async (props: IPeopleProperty | null) => {
  if (!props) return;
  await identifyMixPanelUser(props.personId);
  mixpanel.people.set(props);
};

export const trackMixPanel = (eventName: string, props?: {}) => {
  if (!mixpanel.track) return;
  mixpanel.track(eventName, props);
};
